// chakra imports
import { Box, ChakraProvider } from "@chakra-ui/react";
// core components
import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { default as routes } from "auth_routes.js";
import theme from "theme/theme.js";

export default function Pages(props) {
  const { ...rest } = props;
  // ref for the wrapper div
  const wrapper = React.createRef();
  React.useEffect(() => {
    document.body.style.overflow = "unset";
    // Specify how to clean up after this effect:
    return function cleanup() {};
  });

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      return (
        <Route
          exact={true}
          path={prop.path}
          component={prop.component}
          key={key}
        />
      );
    });
  };

  return (
    <ChakraProvider theme={theme} resetCss={false} w="100%">
      <Box
        minH="100vh"
        bg="linear-gradient(135deg, #1a202c 0%, #2d3748 50%, #1a202c 100%)"
        position="relative"
        overflow="hidden"
      >
        {/* Decorative background elements */}
        <Box
          position="absolute"
          top="-20%"
          right="-10%"
          w="50%"
          h="60%"
          bg="linear-gradient(135deg, rgba(45, 107, 63, 0.15) 0%, rgba(31, 90, 47, 0.1) 100%)"
          borderRadius="full"
          filter="blur(60px)"
          pointerEvents="none"
        />
        <Box
          position="absolute"
          bottom="-20%"
          left="-10%"
          w="40%"
          h="50%"
          bg="linear-gradient(135deg, rgba(45, 107, 63, 0.1) 0%, rgba(31, 90, 47, 0.15) 100%)"
          borderRadius="full"
          filter="blur(60px)"
          pointerEvents="none"
        />

        {/* Main Content */}
        <Box
          ref={wrapper}
          w="100%"
          minH="100vh"
          display="flex"
          alignItems="center"
          justifyContent="center"
          position="relative"
          zIndex={1}
          py={8}
        >
          <Switch>
            {getRoutes(routes)}
            <Redirect from="/auth" to="/auth/signin" />
          </Switch>
        </Box>
      </Box>
    </ChakraProvider>
  );
}
